export enum PasswordStrength {
	Empty = 0,
	Invalid = 1,
	Fair = 2,
	Good = 3,
	Strong = 4,
}
